import Debug from 'debug';
import * as React from 'react';
import { Button, Form, FormControl, FormGroup, FormLabel, Modal, Spinner, Stack } from 'react-bootstrap';
import { notify, NotifyInfo } from '../ancillary/NotifyManager';
import { useNavigate } from 'react-router-dom';

const debug = Debug('gfe/au/Login');

interface LoginProps {
  signIn: (userName: string, password: string) => Promise<NotifyInfo>;
}

export const Login = (props: LoginProps): React.JSX.Element => {
  const [isLoading, setLoading] = React.useState<boolean>(false);
  const userNameRef = React.useRef<HTMLInputElement | null>(null);
  const passwordRef = React.useRef<HTMLInputElement | null>(null);
  const navigate = useNavigate();

  const handleFormSubmit = (event: React.FormEvent) => {
    login();
    event.preventDefault();
  };

  const login = async () => {
    try {
      const userName = userNameRef.current?.value || '';
      const password = passwordRef.current?.value || '';
      setLoading(true);
      debug(`calling signIn(${userName}, xxx)`);
      const resp = await props.signIn(userName, password);
      notify(resp);
      debug(resp);
      setLoading(false);
      if (resp[1] === 'success') {
        navigate('/admin');
      }
    } catch (err) {
      console.error(err);
      notify([String(err), 'danger']);
      setLoading(false);
    }
  };

  return (
    <Modal show={true} backdrop="static" centered={true}>
      <Modal.Header>
        <Modal.Title>Login</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleFormSubmit}>
          <Stack gap={3}>
            {/* <Alert variant={props.userMessage[1]}>{props.userMessage[0]}</Alert> */}
            <FormGroup controlId="username">
              <FormLabel>User name</FormLabel>
              <FormControl type="text" ref={userNameRef} autoComplete="username" />
            </FormGroup>
            <FormGroup controlId="password">
              <FormLabel>Password</FormLabel>
              <FormControl type="password" ref={passwordRef} autoComplete="current-password" />
            </FormGroup>
            <Stack
              direction="horizontal"
              style={{
                justifyContent: 'flex-end',
              }}
            >
              {/* <Button variant="link" onClick={props.requestPasswordReset}>
                Forgotten password?
              </Button> */}
              <Button variant="primary" type="submit">
                {isLoading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
                {!isLoading && 'Log in'}
              </Button>
            </Stack>
          </Stack>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
